// extracted by mini-css-extract-plugin
module.exports = {"btn":"SalonButtons_btn__Tkypq","teal":"SalonButtons_teal__V2HfD","un":"SalonButtons_un__vJ4lG"};